import { Button } from "components/ui/Button";
import { Loading } from "components/ui/Loading/Loading";
import type { SalesPipelineItem } from "hooks/use-sales-pipelines-api";
import type React from "react";

type DeletePipelineModalProps = {
  pipeline: SalesPipelineItem;
  onConfirm: () => Promise<void>;
  onClose: () => void;
  deleting: boolean;
};

/**
 * 営業進捗の削除確認モーダル
 * @param {object} props コンポーネントプロパティ
 * @param {SalesPipelineItem} props.pipeline 削除対象の営業進捗
 * @param {Function} props.onConfirm 削除実行コールバック
 * @param {Function} props.onClose 閉じるコールバック
 * @param {boolean} props.deleting 削除処理中フラグ
 * @return {React.ReactElement} モーダル要素
 */
export const DeletePipelineModal: React.FC<DeletePipelineModalProps> = ({
  pipeline,
  onConfirm,
  onClose,
  deleting,
}) => {
  return (
    <div className="modal modal-open">
      <div className="modal-box w-11/12 max-w-md">
        <h3 className="font-bold text-lg mb-4">営業進捗を削除</h3>
        <p className="text-sm mb-2">この営業進捗を削除しますか？</p>
        <div className="bg-base-200 rounded-lg p-3 text-sm space-y-1">
          <div>
            <span className="text-base-content/60">タレント: </span>
            <span className="font-medium">{pipeline.talentName || "-"}</span>
          </div>
          <div>
            <span className="text-base-content/60">案件: </span>
            <span className="font-medium">
              {pipeline.focusMatterTitle ||
                pipeline.matterTitle ||
                pipeline.clientCompany ||
                "-"}
            </span>
          </div>
        </div>
        <p className="text-xs text-error mt-3">この操作は取り消せません。</p>
        <div className="modal-action">
          <Button
            type="button"
            variant="ghost"
            size="sm"
            onClick={onClose}
            disabled={deleting}
          >
            キャンセル
          </Button>
          <Button
            type="button"
            variant="destructive"
            size="sm"
            onClick={onConfirm}
            disabled={deleting}
          >
            {deleting ? <Loading size="xs" /> : "削除"}
          </Button>
        </div>
      </div>
      <div className="modal-backdrop" onClick={() => !deleting && onClose()} />
    </div>
  );
};
